import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export const Testimonials = () => {
  return (
    <section className="relative bg-brand-blue-dark py-24 lg:py-32 overflow-hidden">
      <div className="pointer-events-none absolute -top-20 right-0 h-96 w-96 rounded-full bg-brand-green/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -left-20 h-96 w-96 rounded-full bg-brand-blue-light/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          variants={fadeUp}
          className="font-serif-accent italic text-lg text-brand-green-light"
        >
          Kind words
        </motion.p>
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          variants={fadeUp}
          className="mt-3 max-w-2xl font-heading font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight"
        >
          Trusted by families across Jodhpur.
        </motion.h2>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          variants={stagger}
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              variants={fadeUp}
              whileHover={{ y: -6 }}
              className="flex flex-col rounded-3xl bg-white/5 backdrop-blur-md border border-white/10 p-7 transition-colors hover:bg-white/10"
            >
              <Quote className="h-8 w-8 text-brand-green-light" />
              <div className="mt-4 flex gap-1 text-brand-green-light">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-200">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <p className="font-heading font-semibold text-white">{t.name}</p>
                <p className="text-xs text-slate-400">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
